/**
 * Phase 5 Task 8 — PacingMonitor.
 *
 * Real-time pacing display: dial rate, abandon rate (color-coded),
 * and pacing factor.
 */
import type { JSX } from 'react'

interface Props {
  dialRate: number
  abandonRate: number
  pacingFactor: number
}

function abandonRateColor(rate: number): string {
  if (rate > 3) return 'text-red-600'
  if (rate >= 2) return 'text-yellow-600'
  return 'text-green-600'
}

export function PacingMonitor({ dialRate, abandonRate, pacingFactor }: Props): JSX.Element {
  return (
    <div
      className="flex gap-6 p-3 border rounded bg-white shadow-sm text-sm"
      data-testid="pacing-monitor"
    >
      <div className="flex flex-col items-center gap-0.5">
        <span className="text-xs text-gray-500 uppercase tracking-wide">Dial Rate</span>
        <span className="font-semibold" data-testid="dial-rate">
          {dialRate} <span className="text-gray-400 font-normal">dials/min</span>
        </span>
      </div>

      <div className="flex flex-col items-center gap-0.5">
        <span className="text-xs text-gray-500 uppercase tracking-wide">Abandon Rate</span>
        <span
          className={`font-semibold ${abandonRateColor(abandonRate)}`}
          data-testid="abandon-rate"
        >
          {abandonRate.toFixed(1)}%
        </span>
      </div>

      <div className="flex flex-col items-center gap-0.5">
        <span className="text-xs text-gray-500 uppercase tracking-wide">Pacing Factor</span>
        <span className="font-semibold" data-testid="pacing-factor">
          {pacingFactor}
        </span>
      </div>
    </div>
  )
}
